import pick from 'lodash/pick';
import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';

import { AI_AGENT_REPORT_TYPE } from '@/ai-agents/components/ai-agents.constants';

export function minifyReports (reports) {
    return reports.map((report) => {
        if (['visitor', 'account', 'parentAccount'].includes(report.definition?.kind)) {
            mapSegmentData(report, report);

            return report;
        }
        if (report.type === AI_AGENT_REPORT_TYPE) {
            mapSegmentData(report, { ...report, reportType: report.type });

            return report;
        }

        const reportType = report.type || report.definition.type;
        const minifiedReport = pick(report, [
            'id',
            'rootVersionId',
            'stableVersionId',
            'name',
            'description',
            'kind',
            'type',
            'owner',
            'lastUpdatedByUser',
            'lastUpdatedAt',
            'createdAt',
            'createdByUser',
            'createdByDashboardTemplate',
            'shared',
            'definition.aiAgentId',
            'definition.config.primaryKey',
            'lastSuccessRunObj',
            'definition.history',
        ]);

        const finalReport = { ...minifiedReport, type: reportType };

        if (report.definition?.config?.appId) {
            const { appId } = report.definition.config;

            finalReport.appId = appId;
        } else if (report.definition?.config?.app?.id) {
            const { id: appId } = report.definition.config.app;
            finalReport.appId = appId;
        }

        mapSegmentData(report, finalReport);

        return finalReport;
    });
}

// Some saved funnels still persist steps under the legacy misspelled `featuerId` key;
// the aggregation engine only ever recognized `featureId`, so those steps have always
// silently failed to match - heal the key on load rather than carrying the typo forward.
export function migrateFunnelFeatureIdTypo (report) {
    const items = report.definition?.config?.items;

    if (!isArray(items)) return;

    items.forEach((item) => {
        if (Object.prototype.hasOwnProperty.call(item, 'featuerId')) {
            item.featureId = item.featuerId;
            delete item.featuerId;
        }
    });
}

export function mapPermission (workflow) {
    const result = cloneDeep(workflow);
    result.permission = result.subscriptionSharing.permission;
    delete result.subscriptionSharing;

    return result;
}

export function mapSegmentData (report, finalReport) {
    if (report.definition?.config?.segmentId) {
        finalReport.segmentId = report.definition.config.segmentId;
    } else if (report.definition?.globals?.segments?.value?.id) {
        finalReport.segmentId = report.definition.globals.segments.value.id;
    } else if (report.definition?.config?.segment?.id) {
        finalReport.segmentId = report.definition.config.segment.id;
    }

    if (report.definition?.globals?.segments && isArray(report.definition.globals.segments)) {
        finalReport.segments = report.definition.globals.segments.map((segment) => {
            return {
                id: segment.value.id,
                compound: segment.value.compound,
                name: segment.value.name,
            };
        });
    }
}
